import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Partenaire, PartenaireService } from 'src/app/core/services/partenaire.service';

@Component({
  selector: 'app-liste-partenaires',
  templateUrl: './liste-partenaires.component.html',
  styleUrls: ['./liste-partenaires.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ListePartenairesComponent implements OnInit {

  partenaires: Partenaire[] = [];
  partenairesAffiches: Partenaire[] = [];
  tableauBord: any = null;
  chargement = true;
  chargementBord = true;
  rechercheTexte = '';
  filtreContrat = '';
  filtreStatut = '';
  messageFlash: { type: 'success' | 'error', texte: string } | null = null;
  confirmeSuppression: Partenaire | null = null;
  confirmeClotureId: number | null = null;

  constructor(
    private service: PartenaireService,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.chargerListe();
    this.chargerTableauBord();
  }

  chargerListe(): void {
    this.chargement = true;
    this.service.listerPartenaires().subscribe({
      next: (data) => {
        this.partenaires = data;
        this.filtrer();
        this.chargement = false;
        this.cdr.markForCheck();
      },
      error: () => { this.chargement = false; this.cdr.markForCheck(); }
    });
  }

  chargerTableauBord(): void {
    this.service.tableauBord().subscribe({
      next: (d) => { this.tableauBord = d; this.chargementBord = false; this.cdr.markForCheck(); },
      error: () => { this.chargementBord = false; this.cdr.markForCheck(); }
    });
  }

  filtrer(): void {
    let liste = [...this.partenaires];
    if (this.rechercheTexte.trim()) {
      const q = this.rechercheTexte.toLowerCase();
      liste = liste.filter(p =>
        (p.nomProprietaire || '').toLowerCase().includes(q) ||
        (p.immatriculation || '').toLowerCase().includes(q) ||
        (p.contactProprietaire || '').toLowerCase().includes(q)
      );
    }
    if (this.filtreContrat) {
      liste = liste.filter(p => p.typeContrat === this.filtreContrat);
    }
    if (this.filtreStatut === 'actif') {
      liste = liste.filter(p => p.enService);
    } else if (this.filtreStatut === 'inactif') {
      liste = liste.filter(p => !p.enService);
    }
    this.partenairesAffiches = liste;
  }

  reinitialiserFiltres(): void {
    this.rechercheTexte = '';
    this.filtreContrat = '';
    this.filtreStatut = '';
    this.filtrer();
  }

  nouveau(): void {
    this.router.navigate(['/partenaires/nouveau']);
  }

  modifier(p: Partenaire): void {
    this.router.navigate(['/partenaires/modifier', p.id]);
  }

  demanderSuppression(p: Partenaire): void {
    this.confirmeSuppression = p;
  }

  annulerSuppression(): void {
    this.confirmeSuppression = null;
  }

  confirmerSuppression(): void {
    if (!this.confirmeSuppression?.id) return;
    this.service.supprimerPartenaire(this.confirmeSuppression.id).subscribe({
      next: () => {
        this.flash('success', 'Partenaire supprimé.');
        this.confirmeSuppression = null;
        this.chargerListe();
      },
      error: () => this.flash('error', 'Erreur lors de la suppression.')
    });
  }

  toggleService(p: Partenaire): void {
    if (!p.id) return;
    this.service.changerStatutService(p.id, !p.enService).subscribe({
      next: () => { this.flash('success', `Partenaire ${!p.enService ? 'activé' : 'désactivé'}.`); this.chargerListe(); },
      error: () => this.flash('error', 'Erreur.')
    });
  }

  demanderCloture(id: number): void {
    this.confirmeClotureId = id;
  }

  annulerCloture(): void {
    this.confirmeClotureId = null;
  }

  confirmerCloture(): void {
    if (!this.confirmeClotureId) return;
    this.service.cloturerMois(this.confirmeClotureId).subscribe({
      next: () => {
        this.flash('success', 'Clôture mensuelle effectuée — compteurs remis à zéro.');
        this.confirmeClotureId = null;
        this.chargerListe();
        this.chargerTableauBord();
      },
      error: () => this.flash('error', 'Erreur lors de la clôture.')
    });
  }

  libelleContrat(code: string): string {
    const m: any = { PAR_LIVRAISON: 'Par livraison', MENSUEL: 'Mensuel fixe', HYBRIDE: 'Hybride' };
    return m[code] || code;
  }

  montantDu(p: Partenaire): number {
    if (p.typeContrat === 'PAR_LIVRAISON') return (p.montantParLivraison || 0) * (p.livraisonsMois || 0);
    if (p.typeContrat === 'MENSUEL') return p.montantMensuel || 0;
    return (p.montantGenereMois || 0);
  }

  formaterMontant(m: number): string {
    return new Intl.NumberFormat('fr-FR', { minimumFractionDigits: 0 }).format(m || 0);
  }

  flash(type: 'success' | 'error', texte: string): void {
    this.messageFlash = { type, texte };
    setTimeout(() => this.messageFlash = null, 4000);
  }
}
